export default function GetAge(DOBdd, DOBmm, DOByyyy) {
  const logging = false;
  const today = new Date();
  const yyyy = today.getFullYear();
  let mm = today.getMonth() + 1; // Months start at 0!
  let dd = today.getDate();
  if (logging === true) console.log("today", `${mm},${dd}, ${yyyy}`);

  if (logging === true) console.log("DoB", `${DOBmm},${DOBdd}, ${DOByyyy}`);
  var ageThisYear = yyyy - DOByyyy - 1;
  if (DOBmm < mm) {
    ageThisYear += 1;
    if (logging === true) console.log("past dob month");
  } else {
    if (logging === true) console.log("not past month");
    if (logging === true) console.log("mm :>> ", mm);
    if (logging === true) console.log("DOBmm :>> ", DOBmm);
    if (parseInt(DOBmm) === parseInt(mm)) {
      if (logging === true) console.log("in month");
      if (parseInt(DOBdd) <= parseInt(dd)) {
        if (logging === true) console.log("past their birthday");
        ageThisYear += 1;
      }
    }
  }
  if (logging === true) console.log("ageThisYear :>> ", ageThisYear);
  return ageThisYear;
}
